import * as React from 'react';
import { SVGProps } from 'react';

const SvgFolder = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='1em'
    height='1em'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#folder_svg__a)'>
      <path
        d='m8.55 5.481 2.443 2.526.414.437h9.164v10.852H3.43V5.481H8.55ZM8.55 4H3.429c-.38 0-.743.156-1.01.434A1.51 1.51 0 0 0 2 5.48v13.815c0 .393.15.77.418 1.048s.632.434 1.01.434h17.143c.38 0 .743-.156 1.01-.434A1.51 1.51 0 0 0 22 19.296V8.444c0-.392-.15-.77-.418-1.047a1.403 1.403 0 0 0-1.01-.434H12L9.564 4.437a1.427 1.427 0 0 0-.465-.324A1.384 1.384 0 0 0 8.55 4Z'
        fill='#000'
      />
    </g>
    <defs>
      <clipPath id='folder_svg__a'>
        <path fill='#fff' d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
);

export default SvgFolder;
